<div class="acc-header" (click)="toggle()">
	<div class="headerTitle">
		{{title}}
	</div>
	<div [@rotatedState]="!showBody ? 'default' : 'rotated'" class="arrow">
		<img class="barrow " src="../../../assets/img/barrow.svg" alt="">
	</div>
</div>
<div [@smoothCollapse]="!showBody ? 'initial' : 'final'">
	<div class="acc-body">
		<ng-content></ng-content>
	</div>
</div>
